import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const ConversationalRoutingForNRO = lazy(() =>
  import("@scenes/ConversationalRouting").then((module) => ({
    default: module.ConversationalRouting,
  }))
);

export const conversationalRoutingNRO: NavigationRoutingObject = {
  Component: ConversationalRoutingForNRO,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  section: "agent-console",
  heading: (t: I18nT<"dashboard-navigation">) => t("conversational-routing-nro-heading", "Conversational Routing"),
  pageNameForTracking: () => "Conversational Routing",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("agent_console_conversational");
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
